import React, { useMemo } from 'react';
import {
  Breakpoint,
  breakpointsValues,
} from '../../BaseComponents/ThemeProvider/AvenyTheme';
import {
  IBreakpointContext,
  BreakpointContextProvider,
} from './BreakpointContextUtils';
import { useTheme, useMediaQuery, UseMediaQueryOptions } from '@mui/material';
import EDBox from '../../BaseComponents/EDBox/EDBox';
import EDTypography from '../../BaseComponents/Typography/EDTypography';

//Ger aktuell breakpoint, ska bara köras på ett ställe och där lagras i context
const options: UseMediaQueryOptions = { noSsr: true };
const useWidthInternal = (): Breakpoint => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up('sm'), options);
  const md = useMediaQuery(theme.breakpoints.up('md'), options);
  const lg = useMediaQuery(theme.breakpoints.up('lg'), options);
  const xl = useMediaQuery(theme.breakpoints.up('xl'), options);
  if (xl) {
    return 'xl';
  }
  if (lg) {
    return 'lg';
  }
  if (md) {
    return 'md';
  }
  if (sm) {
    return 'sm';
  }
  return 'xs';
};

export const GlobalBreakpointContextProvider: React.FC<
  React.PropsWithChildren<{}>
> = props => {
  const breakPoint = useWidthInternal();
  const coarsePointer = useMediaQuery('(pointer: coarse)', options);

  const value: IBreakpointContext = useMemo(
    () => ({
      globalBreakPoint: breakPoint,
      localBreakPoint: breakPoint,
      coarsePointer,
    }),
    [breakPoint, coarsePointer]
  );
  const showBreakpointText = !!window.debug?.showBreakpoint;
  const width = window.innerWidth;
  const height = window.innerHeight;
  const diff = width - breakpointsValues[breakPoint];
  return (
    <BreakpointContextProvider value={value}>
      {showBreakpointText && (
        <EDBox position="absolute" top="auto" left="auto" zIndex={10000}>
          <EDTypography variant="caption" color="hotpink">
            {`${breakPoint} + ${diff}px (${width}x${height})`}
          </EDTypography>
        </EDBox>
      )}
      {props.children}
    </BreakpointContextProvider>
  );
};
